module.exports = __webpack_public_path__ + "assets/img/driver-btn-8f65b1b7.png";